const api = {
  // resourceList:'/openapi/resource/list',
  resourceList:'/hermes/xspark/openapi/web/resource/list',
  searchGroup:'/hermes/xspark/openapi/group/single',
  groupCheckList:'/hermes/xspark/openapi/web/customer/latelyGroupCheckInfo',
  groupRefund:'/hermes/xspark/openapi/web/group/multiRefundTicket',
  individualRefund:'/hermes/xspark/openapi/web/individual/multiRefundTicket',
  // groupOrderDetail:'/openapi/group/orderDetail',
  groupOrderDetail:'/hermes/xspark/openapi/web/group/order/single',
  groupOrderRefundDetail:'/hermes/xspark/openapi/groupOrderRefund/single',
  // indiOrderDetail:'/openapi/indi/orderDetail',
  indiOrderDetail:'/hermes/xspark/openapi/web/individual/order/single',
  indiOrderRefundDetail:'/hermes/xspark/openapi/web/individual/refund/list',
  groupUnifiedOrder:'/hermes/xspark/wechat/unifiedOrder',
  indiUnifiedOrder:'/hermes/xspark/wechat/unifiedIndiOrder',
  getInvoiceNotice:'/hermes/xspark/openapi/web/invoice/notice',
  indiApplyInvoice:'/hermes/xspark/openapi/web/individual/invoice/apply',
  indiInvoiceOrderList:'/hermes/xspark/openapi/web/individual/invoice/available/order/list',
  groupApplyInvoice:'/hermes/xspark/openapi/web/group/invoice/apply',
  groupInvoiceOrderList:'/hermes/xspark/openapi/web/group/invoice/available/order/list',
  invoiceList:'/hermes/xspark/openapi/web/invoice/list',
  createInvoice:'/hermes/xspark/openapi/web/invoice/create',
  updateInvoice:'/hermes/xspark/openapi/web/invoice/update',
  deleteInvoice:'/hermes/xspark/openapi/web/invoice/delete',
  historyInvoice:'/hermes/xspark/openapi/web/invoice/apply/list',
  indiOrderList:'/hermes/xspark/openapi/individualOrder/list',
  groupOrderList:'/hermes/xspark/openapi/groupOrder/list',
  // userSelect:'/openapi/user/select',
  userSelect:'/hermes/xspark/openapi/web/user/info',
  groupSelect:'/hermes/xspark/openapi/group/single',
  // userUpdate:'/openapi/user/update',
  userUpdate:'/hermes/xspark/openapi/web/pc/user/update',
  // ticketDetail:'/openapi/ticket/detail',
  ticketDetail:'/hermes/xspark/openapi/web/product/single',
  groupCreateOrder:'/hermes/xspark/openapi/web/group/createOrder',
  indiCreateOrder:'/hermes/xspark/openapi/web/individual/createOrder',
  // ticketList:'/openapi/ticket/list',
  ticketList:'/hermes/xspark/openapi/web/product/list',
  createGuideRegister: '/hermes/xspark/openapi/web/customer/register',
  createOrganizationRegister: '/hermes/xspark/openapi/web/company/register',
  // uploadUrl: '/openapi/image/upload',
  uploadUrl: '/hermes/xspark/openapi/web/image/upload',
  noticeList:'/openapi/notice/list',
  noticeInfo: '/openapi/notice/info',
  effectiveList: '/sqbs/openapi/customMadeOrder/effective/list',
  customMadeOrder: '/sqbs/openapi/customMadeOrder/single',
  sqbsTicketList: '/sqbs/openapi/web/customMadeProduct/list',
  sqbsGroupCreateOrder: '/sqbs/openapi/web/customMadeOrder/group/createOrder',
  sqbsIndiCreateOrder: '/sqbs/openapi/web/customMadeOrder/indi/createOrder',
  sqbsOrderDetail:'/sqbs/openapi/customMadeOrder/single',
  refundTicket: '/sqbs/openapi/web/customMadeOrderRefund/refundTicket',
  newPeriodList: '/hermes/trans/base/code/info/list'
}
export default api
